var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5653_26788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34315 21 0 19.6569 0 18V6ZM3 4.5C2.17157 4.5 1.5 5.17157 1.5 6V6.32536L12 12.6254L22.5 6.32536V6C22.5 5.17157 21.8284 4.5 21 4.5H3ZM22.5 8.07464L15.4379 12.3119L22.5 16.6578V8.07464ZM22.4494 18.3879L13.9887 13.1814L12 14.3746L10.0113 13.1814L1.55065 18.3879C1.72162 19.0283 2.30573 19.5 3 19.5H21C21.6943 19.5 22.2784 19.0283 22.4494 18.3879ZM1.5 16.6578L8.56211 12.3119L1.5 8.07464V16.6578Z",
    fill: "#6F93EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5653_26788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.32cc25c1f1d6101659dc80975be4520f.svg";
export { ForwardRef as ReactComponent };